import { motion, useReducedMotion, useScroll, useSpring, useTransform } from "framer-motion";

export const LiquidGlassBackground = () => {
  const reduceMotion = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 42, damping: 22, mass: 0.7 });

  const orangeX = useTransform(progress, [0, 0.5, 1], ["-10%", "12%", "-6%"]);
  const orangeY = useTransform(progress, [0, 0.5, 1], ["-5%", "9%", "15%"]);
  const blueX = useTransform(progress, [0, 0.5, 1], ["8%", "-10%", "5%"]);
  const blueY = useTransform(progress, [0, 0.5, 1], ["0%", "14%", "-7%"]);
  const goldX = useTransform(progress, [0, 0.5, 1], ["-4%", "7%", "11%"]);
  const goldY = useTransform(progress, [0, 0.5, 1], ["11%", "-7%", "5%"]);
  const glassRotate = useTransform(progress, [0, 1], [-8, 16]);

  return (
    <div aria-hidden="true" className="fixed inset-0 z-0 overflow-hidden pointer-events-none" data-testid="liquid-glass-background">
      <div className="absolute inset-0 bg-[linear-gradient(118deg,#EDF5F4_0%,#FBF8F2_31%,#F8EBDD_62%,#EAF2F5_100%)]" />
      <div
        className="absolute inset-0 opacity-90"
        style={{
          background:
            "radial-gradient(62% 58% at 8% 10%, rgba(47,143,146,0.24) 0%, transparent 70%), radial-gradient(58% 64% at 96% 78%, rgba(232,99,15,0.22) 0%, transparent 72%), radial-gradient(46% 52% at 14% 90%, rgba(232,163,61,0.20) 0%, transparent 70%)",
        }}
      />
      <motion.div
        className="absolute -top-[18%] -left-[12%] h-[62vw] w-[62vw] rounded-full opacity-[0.28] blur-[105px] saturate-125 mix-blend-multiply will-change-transform"
        style={{
          ...(reduceMotion ? {} : { x: orangeX, y: orangeY }),
          background: "radial-gradient(circle at 35% 35%, rgba(232,99,15,0.76) 0%, rgba(232,99,15,0.26) 42%, transparent 70%)",
        }}
      />
      <motion.div
        className="absolute top-[8%] -right-[18%] h-[68vw] w-[68vw] rounded-full opacity-[0.26] blur-[115px] saturate-125 mix-blend-multiply will-change-transform"
        style={{
          ...(reduceMotion ? {} : { x: blueX, y: blueY }),
          background: "radial-gradient(circle at 60% 40%, rgba(47,143,146,0.68) 0%, rgba(14,42,71,0.24) 44%, transparent 72%)",
        }}
      />
      <motion.div
        className="absolute -bottom-[22%] left-[12%] h-[58vw] w-[58vw] rounded-full opacity-[0.22] blur-[100px] saturate-125 mix-blend-multiply will-change-transform"
        style={{
          ...(reduceMotion ? {} : { x: goldX, y: goldY }),
          background: "radial-gradient(circle at 45% 45%, rgba(232,163,61,0.68) 0%, rgba(232,99,15,0.22) 46%, transparent 74%)",
        }}
      />
      <motion.div
        className="absolute -inset-[22%] opacity-[0.14] blur-[75px] will-change-transform"
        style={{
          ...(reduceMotion ? {} : { rotate: glassRotate }),
          background: "conic-gradient(from 120deg at 50% 50%, transparent 0deg, rgba(255,255,255,0.76) 72deg, transparent 145deg, rgba(47,143,146,0.38) 220deg, transparent 310deg, rgba(232,99,15,0.28) 360deg)",
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          background: "radial-gradient(ellipse at 50% 34%, rgba(251,248,242,0.74) 0%, rgba(251,248,242,0.48) 44%, rgba(251,248,242,0.10) 78%)",
        }}
      />
      <div className="absolute inset-0 bg-[linear-gradient(105deg,rgba(255,255,255,0.52)_0%,transparent_30%,rgba(255,255,255,0.24)_58%,transparent_100%)]" />
      <div className="noise-overlay" />
    </div>
  );
};
